"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "w-full 2xl:container mx-auto p-4 flex flex-col" };
const _hoisted_2 = { class: "bg-white p-5 mb-4" };
const _hoisted_3 = { class: "uppercase font-bold text-xl border-b-1 border-gray pb-3" };
const _hoisted_4 = { class: "flex flex-col md:flex-row" };
const _hoisted_5 = { class: "flex items-start w-full md:w-1/2 py-2 md:pr-3.5" };
const _hoisted_6 = { class: "font-bold pt-5" };
const _hoisted_7 = { class: "flex items-start w-full md:w-1/2 py-2 md:pl-3.5" };
const _hoisted_8 = { class: "mt-4 pt-4 border-t-1 border-gray flex justify-end" };
const _hoisted_9 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-check" }, null, -1);
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const i18n_1 = require("../../common/i18n");
const securityStore_1 = require("../../stores/security/securityStore");
const toastStore_1 = require("../../stores/toast/toastStore");
const carcassReturnStore_1 = require("../../stores/carcassReturn/carcassReturnStore");
const ShopInput_vue_1 = __importDefault(require("../../components/Form/ShopInput.vue"));
const CarcassReturnRequest_1 = __importDefault(require("../../stores/carcassReturn/CarcassReturnRequest"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'CarcassReturn',
    setup(__props) {
        const carcassReturnRequest = (0, vue_3.ref)(new CarcassReturnRequest_1.default());
        const router = (0, vue_router_1.useRouter)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const carcassStore = (0, carcassReturnStore_1.useCarcassReturnStore)();
        const createCarcass = () => {
            carcassReturnRequest.value.createdUser = securityStore.authenticatedUser.iri;
            carcassStore.createCarcass(router, carcassReturnRequest.value)
                .then((response) => {
                carcassStore.sendCarcassCreatedEmail(router, {
                    carcassId: response.id,
                    quantity: carcassReturnRequest.value.quantity,
                    customerId: securityStore.authenticatedUser.id,
                    customerEmail: securityStore.authenticatedUser.email
                });
                carcassReturnRequest.value.quantity = null;
                toastStore.addToast({
                    message: (0, i18n_1.trans)("carcass_created", "Carcass created", "carcass_return"),
                    type: "success",
                    timer: 5,
                });
            })
                .catch((error) => {
                toastStore.addErrorToast(error.toString());
            });
        };
        (0, vue_3.onBeforeMount)(() => {
            carcassReturnRequest.value = new CarcassReturnRequest_1.default();
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("carcass_return_data", "Carcass return data", "carcass_return")), 1),
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            (0, vue_2.createElementVNode)("div", _hoisted_6, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('quantity', 'Quantity', 'carcass_return')), 1)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_7, [
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                required: "",
                                type: "number",
                                valid: carcassReturnRequest.value.isQuantityValid(),
                                "show-validity": true,
                                modelValue: carcassReturnRequest.value.quantity,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((carcassReturnRequest.value.quantity) = $event)),
                                border: ""
                            }, null, 8, ["valid", "modelValue"])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_8, [
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn btn-rounded btn-primary",
                            onClick: _cache[1] || (_cache[1] = ($event) => (createCarcass()))
                        }, [
                            _hoisted_9,
                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(_ctx.$trans('save', 'Save', 'carcass_return')), 1)
                        ])
                    ])
                ])
            ]));
        };
    }
});
